export const DesignTemplateGPC = [
  {
    pageUid: "GPC",
    pageSectionKey: "logoSettings",
    attributeKey: "gpcFavicon",
    attributeValue: "",
  },
  {
    pageUid: "GPC",
    pageSectionKey: "logoSettings",
    attributeKey: "gpcLandscapeLogo",
    attributeValue: "",
  },
  {
    pageUid: "GPC",
    pageSectionKey: "logoSettings",
    attributeKey: "gpcSquareLogo",
    attributeValue: "",
  },
  {
    pageUid: "GPC",
    pageSectionKey: "backgroundSettings",
    attributeKey: "gpcBackgroundImage",
    attributeValue: "",
  },
  {
    pageUid: "GPC",
    pageSectionKey: "backgroundSettings",
    attributeKey: "gpcBackgroundImageToggle",
    attributeValue: "",
  },
  {
    pageUid: "GPC",
    pageSectionKey: "backgroundSettings",
    attributeKey: "gpcBackgroundImageTransparency",
    attributeValue: "",
  },
  {
    pageUid: "GPC",
    pageSectionKey: "backgroundSettings",
    attributeKey: "gpcPrimaryBgColor",
    attributeValue: "",
  },
  {
    pageUid: "GPC",
    pageSectionKey: "backgroundSettings",
    attributeKey: "gpcSecondaryBgColor",
    attributeValue: "",
  },
  {
    pageUid: "GPC",
    pageSectionKey: "backgroundSettings",
    attributeKey: "gpcSidebarBgColor",
    attributeValue: "",
  },
  {
    pageUid: "GPC",
    pageSectionKey: "textColorsSettings",
    attributeKey: "gpcPrimaryTextColor",
    attributeValue: "",
  },
  {
    pageUid: "GPC",
    pageSectionKey: "textColorsSettings",
    attributeKey: "gpcSecondaryTextColor",
    attributeValue: "",
  },
  {
    pageUid: "GPC",
    pageSectionKey: "navbarSettings",
    attributeKey: "navbarBgColor",
    attributeValue: "",
  },
  {
    pageUid: "GPC",
    pageSectionKey: "navbarSettings",
    attributeKey: "navbarDropdownBgColor",
    attributeValue: "",
  },
  {
    pageUid: "GPC",
    pageSectionKey: "navbarSettings",
    attributeKey: "navbarDropdownTextColor",
    attributeValue: "",
  },
  {
    pageUid: "GPC",
    pageSectionKey: "buttonsSettings",
    attributeKey: "gpcBtnPrimaryBgColor",
    attributeValue: "",
  },
  {
    pageUid: "GPC",
    pageSectionKey: "buttonsSettings",
    attributeKey: "gpcBtnPrimaryTextColor",
    attributeValue: "",
  },
  {
    pageUid: "GPC",
    pageSectionKey: "buttonsSettings",
    attributeKey: "gpcBtnSecondaryBgColor",
    attributeValue: "",
  },
  {
    pageUid: "GPC",
    pageSectionKey: "buttonsSettings",
    attributeKey: "gpcBtnSecondaryTextColor",
    attributeValue: "",
  },
  {
    pageUid: "GPC",
    pageSectionKey: "buttonsSettings",
    attributeKey: "gpcLinkColor",
    attributeValue: "",
  },
  {
    pageUid: "GPC",
    pageSectionKey: "assignmentStatusColorsSettings",
    attributeKey: "gpcCompleted",
    attributeValue: "",
  },
  {
    pageUid: "GPC",
    pageSectionKey: "assignmentStatusColorsSettings",
    attributeKey: "gpcOverdue",
    attributeValue: "",
  },
  {
    pageUid: "GPC",
    pageSectionKey: "assignmentStatusColorsSettings",
    attributeKey: "gpcPending",
    attributeValue: "",
  },
  {
    pageUid: "GPC",
    pageSectionKey: "assignmentStatusColorsSettings",
    attributeKey: "gpcBorderColor",
    attributeValue: "",
  },
  {
    pageUid: "GPC",
    pageSectionKey: "assignmentStatusColorsSettings",
    attributeKey: "gpcBorderSize",
    attributeValue: "",
  },
  {
    pageUid: "GPC",
    pageSectionKey: "assignmentStatusColorsSettings",
    attributeKey: "gpcShadowColor",
    attributeValue: "",
  },
  {
    pageUid: "GPC",
    pageSectionKey: "assignmentStatusColorsSettings",
    attributeKey: "gpcShadowSize",
    attributeValue: "",
  },
] as const;

export const DesignTemplateLogin = [
  {
    pageUid: "LOGIN",
    pageSectionKey: "logoSettings",
    attributeKey: "loginLandscapeLogo",
    attributeValue: "",
  },
  {
    pageUid: "LOGIN",
    pageSectionKey: "logoSettings",
    attributeKey: "loginPoweredBy",
    attributeValue: "",
  },
  {
    pageUid: "LOGIN",
    pageSectionKey: "logoSettings",
    attributeKey: "loginPoweredByLogoLight",
    attributeValue: "",
  },
  {
    pageUid: "LOGIN",
    pageSectionKey: "logoSettings",
    attributeKey: "loginPoweredByLogoDark",
    attributeValue: "",
  },
  {
    pageUid: "LOGIN",
    pageSectionKey: "logoSettings",
    attributeKey: "loginPoweredByLogoMode",
    attributeValue: "",
  },
  {
    pageUid: "LOGIN",
    pageSectionKey: "backgroundSettings",
    attributeKey: "loginBackgroundImage",
    attributeValue: "",
  },
  {
    pageUid: "LOGIN",
    pageSectionKey: "backgroundSettings",
    attributeKey: "loginBackgroundImageToggle",
    attributeValue: "",
  },
  {
    pageUid: "LOGIN",
    pageSectionKey: "backgroundSettings",
    attributeKey: "loginBackgroundImageTransparency",
    attributeValue: "",
  },
  {
    pageUid: "LOGIN",
    pageSectionKey: "backgroundSettings",
    attributeKey: "loginPrimaryBgColor",
    attributeValue: "",
  },
  {
    pageUid: "LOGIN",
    pageSectionKey: "backgroundSettings",
    attributeKey: "loginSecondaryBgColor",
    attributeValue: "",
  },
  {
    pageUid: "LOGIN",
    pageSectionKey: "textColorsSettings",
    attributeKey: "loginPrimaryTextColor",
    attributeValue: "",
  },
  {
    pageUid: "LOGIN",
    pageSectionKey: "textColorsSettings",
    attributeKey: "loginSecondaryTextColor",
    attributeValue: "",
  },
  {
    pageUid: "LOGIN",
    pageSectionKey: "buttonsSettings",
    attributeKey: "loginBtnPrimaryBgColor",
    attributeValue: "",
  },
  {
    pageUid: "LOGIN",
    pageSectionKey: "buttonsSettings",
    attributeKey: "loginBtnPrimaryTextColor",
    attributeValue: "",
  },
  {
    pageUid: "LOGIN",
    pageSectionKey: "buttonsSettings",
    attributeKey: "loginBtnSecondaryBgColor",
    attributeValue: "",
  },
  {
    pageUid: "LOGIN",
    pageSectionKey: "buttonsSettings",
    attributeKey: "loginBtnSecondaryTextColor",
    attributeValue: "",
  },
  {
    pageUid: "LOGIN",
    pageSectionKey: "buttonsSettings",
    attributeKey: "loginLinkColor",
    attributeValue: "",
  },
  {
    pageUid: "LOGIN",
    pageSectionKey: "inputFieldsSettings",
    attributeKey: "inputBorderColor",
    attributeValue: "",
  },
  {
    pageUid: "LOGIN",
    pageSectionKey: "inputFieldsSettings",
    attributeKey: "inputBGColor",
    attributeValue: "",
  },
] as const;

export const DesignTemplateHome = [
  {
    pageUid: "HOME",
    pageSectionKey: "backgroundSettings",
    attributeKey: "homeBackgroundImage",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "backgroundSettings",
    attributeKey: "homeBackgroundImageToggle",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "backgroundSettings",
    attributeKey: "homeBackgroundImageTransparency",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "backgroundSettings",
    attributeKey: "homePrimaryBgColor",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "backgroundSettings",
    attributeKey: "homeSecondaryBgColor",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "textColorsSettings",
    attributeKey: "homePrimaryTextColor",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "textColorsSettings",
    attributeKey: "homeSecondaryTextColor",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "buttonsSettings",
    attributeKey: "homeBtnPrimaryBgColor",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "buttonsSettings",
    attributeKey: "homeBtnPrimaryTextColor",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "buttonsSettings",
    attributeKey: "homeBtnSecondaryBgColor",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "buttonsSettings",
    attributeKey: "homeBtnSecondaryTextColor",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "buttonsSettings",
    attributeKey: "homeLinkColor",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "assignmentStatusColorsSettings",
    attributeKey: "homeCompleted",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "assignmentStatusColorsSettings",
    attributeKey: "homeOverdue",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "assignmentStatusColorsSettings",
    attributeKey: "homePending",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "assignmentStatusColorsSettings",
    attributeKey: "homeBorderColor",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "assignmentStatusColorsSettings",
    attributeKey: "homeBorderSize",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "assignmentStatusColorsSettings",
    attributeKey: "homeShadowColor",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "assignmentStatusColorsSettings",
    attributeKey: "homeShadowSize",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "cardsSettings",
    attributeKey: "cardBorderColor",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "cardsSettings",
    attributeKey: "cardBorderSize",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "cardsSettings",
    attributeKey: "cardShadowColor",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "cardsSettings",
    attributeKey: "cardShadowSize",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "cardsSettings",
    attributeKey: "cardBackgroundColor",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "cardsSettings",
    attributeKey: "cardTransparencyLevel",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "cardsSettings",
    attributeKey: "cardCompletedProgressBarColor",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "cardsSettings",
    attributeKey: "cardInProgressBarColor",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "cardsSettings",
    attributeKey: "cardNotStartedProgressBarColor",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "cardsSettings",
    attributeKey: "cardCourseColor",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "cardsSettings",
    attributeKey: "cardSurveyColor",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "cardsSettings",
    attributeKey: "cardPolicyColor",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "cardsSettings",
    attributeKey: "cardOverdueTextColor",
    attributeValue: "",
  },
  {
    pageUid: "HOME",
    pageSectionKey: "cardsSettings",
    attributeKey: "cardDateTextColor",
    attributeValue: "",
  },
] as const;

export const DesignTemplateCertificate = [
  {
    pageUid: "CERTIFICATES",
    pageSectionKey: "logoSettings",
    attributeKey: "certificatesLogo",
    attributeValue: "",
  },
  {
    pageUid: "CERTIFICATES",
    pageSectionKey: "backgroundSettings",
    attributeKey: "certificatesBackgroundImage",
    attributeValue: "",
  },
  {
    pageUid: "CERTIFICATES",
    pageSectionKey: "backgroundSettings",
    attributeKey: "certificatesBackgroundImageToggle",
    attributeValue: "",
  },
  {
    pageUid: "CERTIFICATES",
    pageSectionKey: "backgroundSettings",
    attributeKey: "certificatesBackgroundImageTransparency",
    attributeValue: "",
  },
  {
    pageUid: "CERTIFICATES",
    pageSectionKey: "backgroundSettings",
    attributeKey: "certificatesPrimaryBgColor",
    attributeValue: "",
  },
  {
    pageUid: "CERTIFICATES",
    pageSectionKey: "backgroundSettings",
    attributeKey: "certificatesSecondaryBgColor",
    attributeValue: "",
  },
  {
    pageUid: "CERTIFICATES",
    pageSectionKey: "textColorsSettings",
    attributeKey: "certificatesPrimaryTextColor",
    attributeValue: "",
  },
  {
    pageUid: "CERTIFICATES",
    pageSectionKey: "textColorsSettings",
    attributeKey: "certificatesSecondaryTextColor",
    attributeValue: "",
  },
  {
    pageUid: "CERTIFICATES",
    pageSectionKey: "buttonsSettings",
    attributeKey: "certificatesBtnPrimaryBgColor",
    attributeValue: "",
  },
  {
    pageUid: "CERTIFICATES",
    pageSectionKey: "buttonsSettings",
    attributeKey: "certificatesBtnPrimaryTextColor",
    attributeValue: "",
  },
  {
    pageUid: "CERTIFICATES",
    pageSectionKey: "buttonsSettings",
    attributeKey: "certificatesBtnSecondaryBgColor",
    attributeValue: "",
  },
  {
    pageUid: "CERTIFICATES",
    pageSectionKey: "buttonsSettings",
    attributeKey: "certificatesBtnSecondaryTextColor",
    attributeValue: "",
  },
  {
    pageUid: "CERTIFICATES",
    pageSectionKey: "buttonsSettings",
    attributeKey: "certificatesLinkColor",
    attributeValue: "",
  },
] as const;

export const DesignTemplateProfile = [
  {
    pageUid: "PROFILE",
    pageSectionKey: "backgroundSettings",
    attributeKey: "profileBackgroundImage",
    attributeValue: "",
  },
  {
    pageUid: "PROFILE",
    pageSectionKey: "backgroundSettings",
    attributeKey: "profileBackgroundImageToggle",
    attributeValue: "",
  },
  {
    pageUid: "PROFILE",
    pageSectionKey: "backgroundSettings",
    attributeKey: "profileBackgroundImageTransparency",
    attributeValue: "",
  },
  {
    pageUid: "PROFILE",
    pageSectionKey: "backgroundSettings",
    attributeKey: "profilePrimaryBgColor",
    attributeValue: "",
  },
  {
    pageUid: "PROFILE",
    pageSectionKey: "backgroundSettings",
    attributeKey: "profileSecondaryBgColor",
    attributeValue: "",
  },
  {
    pageUid: "PROFILE",
    pageSectionKey: "textColorsSettings",
    attributeKey: "profilePrimaryTextColor",
    attributeValue: "",
  },
  {
    pageUid: "PROFILE",
    pageSectionKey: "textColorsSettings",
    attributeKey: "profileSecondaryTextColor",
    attributeValue: "",
  },
  {
    pageUid: "PROFILE",
    pageSectionKey: "buttonsSettings",
    attributeKey: "profileBtnPrimaryBgColor",
    attributeValue: "",
  },
  {
    pageUid: "PROFILE",
    pageSectionKey: "buttonsSettings",
    attributeKey: "profileBtnPrimaryTextColor",
    attributeValue: "",
  },
  {
    pageUid: "PROFILE",
    pageSectionKey: "buttonsSettings",
    attributeKey: "profileBtnSecondaryBgColor",
    attributeValue: "",
  },
  {
    pageUid: "PROFILE",
    pageSectionKey: "buttonsSettings",
    attributeKey: "profileBtnSecondaryTextColor",
    attributeValue: "",
  },
  {
    pageUid: "PROFILE",
    pageSectionKey: "buttonsSettings",
    attributeKey: "profileLinkColor",
    attributeValue: "",
  },
] as const;
